const Roles = {
  SUPER_ADMIN: "super_admin",
  ADMIN: "admin",
  GUIDE: "guide",
};

export default Roles;
